<template>
  <form class="the-form font-mulish" @keydown.prevent.enter="submit" @submit.prevent>
    <div>
      <base-form-logo />
      <p class="tw-mb-6">Recuerda que tu usuario es tu e-mail registrado en EducaciónIT.</p>
      <div>
        <div class="input-container">
          <it-input
            id="login-mail"
            ref="first-input"
            v-model="form.mail"
            label="mi usuario"
            :state="states.mail"
            placeholder="email@gmail.com"
            type="email"
            autocomplete="email"
            @blur="valid('mail')"
          >
            <template v-if="errors.mail" #message> {{ errors.mail }} </template>
          </it-input>
        </div>

        <div class="input-container">
          <it-input
            id="login-password"
            v-model="form.password"
            label="mi contraseña"
            :state="states.password"
            placeholder="*******"
            autocomplete="current-password"
            :type="passwordInputType"
            click-right
            @blur="valid('password')"
            @click-right="togglePasswordVisibility"
          >
            <template v-if="errors.password" #message> {{ errors.password }} </template>
            <template #icon-right>
              <i aria-hidden="true" class="v-icon material-icons tw-block tw-mx-0 tw-w-6">
                {{ passwordIcon }}
              </i>
            </template>
          </it-input>
        </div>

        <p v-if="attempt && !authenticated" class="text-it-error tw-text-center">
          <strong>Usuario o contraseña inválido</strong>
        </p>
      </div>
    </div>

    <div class="buttons">
      <!--
        <p class="caption text-xs-left pb-2">
          Este sitio está protegido por reCAPTCHA y se aplica la
          <a href="https://policies.google.com/privacy" target="_blank">Política de privacidad</a> y los
          <a href="https://policies.google.com/terms" target="_blank">Términos de servicio</a> de Google
        </p>
      -->
      <router-link :to="{ name: 'LostPassword' }" class="tw-block tw-w-auto tw-mx-auto tw-my-4">
        <it-button type="ternary" no-padding class="tw-mx-auto"> Olvidé mi contraseña o usuario</it-button>
      </router-link>

      <it-button
        :disabled="loadingFirebase"
        :loading="loading"
        class="tw-mx-auto"
        @click="submit"
        style="width: 240px;"
      >
        Acceder a mi Alumni
      </it-button>
<!--      <it-button
        :disabled="loading"
        :loading="loadingFirebase"
        class="tw-mx-auto tw-mt-6"
        type="secondary"
        :bordered="true"
        @click="submitSSO"
        style="width: 240px;"
      >
        Acceder con SSO
      </it-button>-->
    </div>
  </form>
</template>

<script>
import FormUtils from "@/mixins/FormUtils"
import BaseFormLogo from "@/components/BaseFormLogo"
export default {
  name: "LoginForm",
  components: { BaseFormLogo },
  mixins: [FormUtils],
  data() {
    return {
      attempt: false,
      passwordVisible: false,

      loading: false,
      loadingFirebase: false,
      form: {
        mail: "",
        password: ""
      },
      rules: {
        mail: {
          required: true,
          type: String,
          min: 8,
          message: {
            required: "el campo es requerido",
            min: "debe tener un mínimo de 8 caracteres",
            email: "debe ser un email válido"
          },
          clean: { trim: true },
          email: true
        },
        password: {
          required: true,
          type: String,
          min: 1,
          message: {
            required: "el campo es requerido",
            min: "debe tener un mínimo de 1 caracteres"
          },
          clean: { trim: true }
        }
      }
    }
  },
  computed: {
    authenticated() {
      return this.$store.state.Auth.authenticated
    },
    hasErrors() {
      return !!Object.values(this.errors).filter(err => err).length
    },
    passwordInputType() {
      return this.passwordVisible ? "text" : "password"
    },
    passwordIcon() {
      return this.passwordVisible ? "visibility_on" : "visibility_off"
    }
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible
    },

    async submit() {
      this.loading = true

      const { err: validationErr, values } = await this.validateAll()

      if (validationErr) return (this.loading = false)

      try {
        await this.$store.dispatch("Auth/login", { username: values.mail, password: values.password })
      } catch (err) {
        console.log("err")
        if (!this.authenticated) {
          this.loading = false
          return (this.attempt = true)
        }
      }

      this.$router.push({ name: "courses" }).catch(() => {})
    },
    async submitSSO() {
      this.loadingFirebase = true
      let authUser = this.$store.state.AuthFirebase.authUser

      await this.$store.dispatch("AuthFirebase/checkAuthRoute", authUser)

      if (!authUser) {
        this.loadingFirebase = false
        return
      }

      this.$router.push({ name: "courses" }).catch(() => {})
    }
  }
}
</script>

<style lang="postcss" scoped>
.the-form {
  @apply tw-h-screen tw-w-full sm:tw-w-96 sm:tw-h-auto tw-mx-auto tw-absolute  tw-bg-white tw-z-10 tw-py-6 tw-px-10 tw-top-1/2 tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2 tw-flex tw-flex-col tw-justify-between;
}

.input-container {
  height: 85px;
}
</style>
